<template>
  <div class="mobile-modal-overlay bg-[rgba(0,0,0,0.6)] fixed inset-0 z-50 flex items-end justify-center" @click.self="$emit('close')">
    <div class="mobile-modal-sheet rounded-2xl bg-white w-full max-w-md mx-auto p-6 shadow-lg">
      <div class="text-center text-[#0033A0] text-2xl font-bold mb-4 tracking-wide ">Join Meeting</div>
      <div class="space-y-6 pt-2">
        <div>
          <label for="meeting-id" class="text-[#0033A0] font-semibold">Meeting ID</label>
          <input
            id="meeting-id"
            :value="meetingId"
            @input="$emit('update:meetingId', $event.target.value)"
            placeholder="Enter Meeting ID"
            class="mt-2 w-full px-4 py-3 bg-[#E8EFF5] text-[#1A1A1A] rounded-2xl border border-[#D1E0ED] focus:ring-2 focus:ring-[#0033A0] focus:outline-none placeholder-gray-400"
          />
        </div>
        <button
          @click="$emit('join')"
          class="w-full h-12 bg-[#0033A0] hover:bg-[#002580] text-white text-base font-bold rounded-2xl shadow-sm transition-colors duration-150 flex items-center justify-center"
        >
          Join
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  meetingId: {
    type: String,
    required: true
  }
})

defineEmits(['close', 'join', 'update:meetingId'])
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
